import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Stay } from '../../types'
import StayCard from '../common/StayCard'
import SwiperCards from '../common/SwiperCards'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { fetchPopularStays } from '../../features/admin/placeSlice'
import Loading from '../ui/Loading'

const PopularStays = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const [localStays, setLocalStays] = useState<Stay[]>([])
  const { popularStays, staysPagination,loading } = useSelector((state: RootState) => state.placeSlice)
  const { user } = useSelector((state: RootState) => state.user)
  useEffect(() => {
    dispatch(fetchPopularStays({ userId: user?.id, page: 1 }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

useEffect(() => {
  if (popularStays.length) {
    setLocalStays((prev) => {
      if (staysPagination?.currentPage === 1) {
        return popularStays;
      }
      return [...prev, ...popularStays];
    });
  }
}, [popularStays, staysPagination?.currentPage]);
if(popularStays.length===0) return null;
if(loading )return <Loading/>
  return (
    <div className='main-prop '>
      <div className='padding-container'>
        <h2 className=' xs:text-2xl md:text-4xl font-semibold pb-2'>{t("popular-stays")}</h2>
      </div>

      <div className='mt-8'>
        <SwiperCards
          currentPage={staysPagination?.currentPage}
          lastPage={staysPagination?.lastPage}
          onLoadMore={() => {
            if (staysPagination) {
              dispatch(fetchPopularStays({ userId: user?.id ?? undefined, page: staysPagination.currentPage + 1 }));
            }
          }}
        >
          {localStays.map((stay: Stay, index: number) => (
              <StayCard key={index} stay={stay} userId={user?.id} />
           
            
          ))}
        </SwiperCards>
      </div>
    </div>
  )
}

export default PopularStays
